<template>
  <div style="padding: 30px">
    <div class="d-flex justify-space-between align-center mb-4">
      <h2 class="text-h5">Production Partners</h2>
      <v-btn color="primary" @click="fetchFromApi" :loading="fetching" class="text-capitalize">
        <v-icon left>{{ icons.mdiDownload }}</v-icon>
        Fetch from Etsy API
      </v-btn>
    </div>

    <v-data-table :headers="headers" :items="partners" :items-per-page="10" class="elevation-1 mt-5">
      <template v-slot:top>
        <v-row style="padding: 10px">
          <v-col md="2" cols="6">
            <strong>Total: </strong> {{ partners.length }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:body="{ items }">
        <tbody v-if="!is_loading">
          <tr v-if="!items.length">
            <td colspan="4" class="text-center" style="padding: 20px 0px">
              <img :src="require('@/assets/images/misc/no-data.png')" alt="" width="250px" />
              <p style="font-size: 25px">No Data Found!!</p>
            </td>
          </tr>
          <tr v-for="item in items" :key="item.production_partner_id">
            <td>{{ item.production_partner_id }}</td>
            <td>
              <v-icon left color="primary">{{ icons.mdiFactory }}</v-icon>
              {{ item.partner_name }}
            </td>
            <td>
              <v-icon left color="secondary">{{ icons.mdiMapMarker }}</v-icon>
              {{ item.location }}
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="4" class="text-center" style="padding: 80px 0px">
              <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import store from '@/store'
import { mdiDownload, mdiFactory, mdiMapMarker } from '@mdi/js'

export default {
  data() {
    return {
      shop: null,
      is_loading: false,
      fetching: false,
      partners: [],
      headers: [
        { text: 'Partner ID', value: 'production_partner_id' },
        { text: 'Partner Name', value: 'partner_name' },
        { text: 'Location', value: 'location' },
      ],
      icons: {
        mdiDownload: mdiDownload,
        mdiFactory: mdiFactory,
        mdiMapMarker: mdiMapMarker,
      },
    }
  },
  mounted() {
    this.shop = store.getters.loggedInShop
    this.fetchPartners()
  },
  methods: {
    async fetchPartners() {
      try {
        this.is_loading = true
        let response = await axios.get(`/admin/shops/${this.shop.id}/production-partners`)
        if (response.data.success) {
          this.partners = response.data.data || []
        }
      } catch (e) {
        console.error('Error fetching production partners:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch production partners',
        })
      } finally {
        this.is_loading = false
      }
    },
    async fetchFromApi() {
      try {
        this.fetching = true
        let response = await axios.get(`/admin/shops/${this.shop.id}/production-partners/fetch`)
        if (response.data.success) {
          this.$swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message || 'Production partners fetched successfully',
          })
          await this.fetchPartners()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.data.message || 'Failed to fetch production partners',
          })
        }
      } catch (e) {
        console.error('Error fetching from API:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch production partners from Etsy API',
        })
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>


